<mat-card class="mcd-card">
  <mat-card-header class="mcd-card-header">
    <mat-card-title class="mcd-card-title"
      >Equipment Standard List</mat-card-title
    >
  </mat-card-header>
  <mat-card-content class="mcd-card-content">
    <div class="row filter-panel-row">
      <div class="col filter-panel">
        <app-location-type-filter
          [standardFiltration]="standardFiltrationForChipSet"
          [standardListType]="standardListType.NationalEquipment"
          (messageEvent)="receivedFilteration($event)"
        ></app-location-type-filter>
      </div>
      <div class="collpsible-panel">
        <button class="btn-collapse" mat-icon-button aria-label="Collapse">
          <i class="material-icons"> expand_less </i>
        </button>
        <button class="btn-expand" mat-icon-button aria-label="Expand">
          <mat-icon>expand_more</mat-icon>
        </button>
      </div>
    </div>
    <div *ngIf="!loading">
      <div class="row">
        <div class="col-md-9">
          <mat-form-field>
            <input
              matInput
              placeholder="Search by Title, Model or Description"
              value="{{ searchKey }}"
              (keyup.enter)="addSearchKey(key)"
              name="search"
              #key
            />
            <button
              mat-button
              *ngIf="searchKey"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="searchKey = ''; addSearchKey(searchKey)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="col float-right">
          <!-- <button disabled> -->
          <a *ngIf="isDownloading" class="float-right" disabled>
            Downloading, Please wait...
            <svg
              class="fontawesomesvg"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 384 512"
            >
              <!--! Font Awesome Free 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2022 Fonticons, Inc. -->
              <path
                d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM155.7 250.2L192 302.1l36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L162.7 344l-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z"
              />
            </svg>
          </a>
          <a
            *ngIf="!isDownloading"
            class="float-right"
            href="javascript:void(0);"
            (click)="downloadExcel()"
            style="color: #0b59ca; text-decoration: none; cursor: pointer"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="margin-bottom: 2px; margin-right: 2px"
            >
              <path
                d="M8.5 5V1H5.5V5H3.5L7 9L10.5 5H8.5Z"
                stroke="#3C74E0"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.5 9V11.5C12.5 11.8978 12.342 12.2794 12.0607 12.5607C11.7794 12.842 11.3978 13 11 13H3C2.60218 13 2.22064 12.842 1.93934 12.5607C1.65804 12.2794 1.5 11.8978 1.5 11.5V9"
                stroke="#3C74E0"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Download All
          </a>
          <!-- </button> -->
        </div>
      </div>
      <div class="row">
        <div class="col-6" *ngIf="this.equipmentItems.length > 0">
          <mat-form-field>
            <mat-select
              [value]="pageSize"
              name="nOfRows"
              #items
              (selectionChange)="selectedItemsPerPageChange(items)"
            >
              <mat-option [value]="item.value" *ngFor="let item of pageSizes">
                {{ item.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col">
          <mat-form-field class="float-right">
            <mat-label>Country</mat-label>
            <mat-select
              name="dropCategory"
              [value]="selectedCountryId"
              #country
              (selectionChange)="selectCountry(country)"
            >
              <mat-option
                *ngFor="let item of countries; let j = index"
                [value]="item.id"
                >{{ item.name }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div *ngIf="this.equipmentItems.length > 0" class="col-md-12">
        <table
          class="table nrbes-grid"
          matSort
          (matSortChange)="sortData($event)"
        >
          <thead class="thead-light">
            <tr>
              <th width="110" mat-sort-header="type" scope="col-2">
                Equipment Type
              </th>
              <th width="110" mat-sort-header="supplier" scope="col-2">
                Supplier
              </th>
              <th scope="col-4" mat-sort-header="title" width="20%">Title</th>
              <th scope="col" mat-sort-header="model" width="110">Model</th>
              <th scope="col" mat-sort-header="class" width="110">
                Equipment Class
              </th>
              <th scope="col-4" width="10%">Location Type</th>
              <th scope="col-4" width="15%">Obsolete Date</th>
              <th
                scope="col"
                width="80"
                *ngIf="
                  userRole == userRoleEnum.GlobalAdmin ||
                  userRole == userRoleEnum.AOWAdmin ||
                  userRole == userRoleEnum.MarketAdmin
                "
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of nrbesItems" (click)="rowSelected(item)">
              <td class="category-cell" style="font-weight: bold;">
                {{ item.standard.equipmentStandard.equipmentType.name }}
              </td>
              <td class="category-cell">
                {{ item.standard.equipmentStandard.supplier.name }}
              </td>
              <td class="title-cell">{{ item.standard.title }}</td>
              <td class="location-cell">
                {{ item.standard.equipmentStandard.model }}
              </td>
              <td class="location-cell">
                {{ item.standard.equipmentStandard.equipmentClassType.name }}
              </td>
              <td class="category-cell">
                {{ getLocationNames(item) }}
              </td>
              <td
                class="category-cell"
                *ngIf="
                  item?.standard?.equipmentStandard?.obsoleteDate != null;
                  else elseBlock
                "
              >
                Obsolete Date -
                {{
                  item.standard.equipmentStandard.obsoleteDate
                    | date : "MM.dd.yyyy"
                }}
              </td>
              <ng-template #elseBlock>
                <td class="category-cell">
                  Obsolete Date Not Set
                </td></ng-template
              >
              <th scope="col" width="80" *ngIf="canEditEquipmentStandard">
                Actions
              </th>

              <td
                *ngIf="
                  userRole == userRoleEnum.GlobalAdmin ||
                  userRole == userRoleEnum.AOWAdmin ||
                  userRole == userRoleEnum.MarketAdmin
                "
              >
                <div class="row grid-actions hide-sm">
                  <div class="col-6">
                    <a
                      class="action-controls"
                      (click)="openDeletePopup(item, $event)"
                      routerLinkActive="active"
                      title="clear"
                      ><i class="material-icons"> clear </i></a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      class="action-controls"
                      (click)="onEdit(item.standardId, $event)"
                      routerLinkActive="active"
                      title="Edit"
                      href="javascript:void(0);"
                      ><i class="material-icons"> create </i></a
                    >
                  </div>
                </div>

                <a
                  (click)="actionMenuOpen($event)"
                  class="mcd-more-btn show-sm"
                  [matMenuTriggerFor]="menu"
                  href="javascript:void(0);"
                >
                  <i class="material-icons">more_vert</i>
                </a>
                <mat-menu #menu="matMenu" overlapTrigger="false">
                  <span>
                    <button
                      *ngIf="
                        userRole == userRoleEnum.GlobalAdmin ||
                        userRole == userRoleEnum.AOWAdmin ||
                        userRole == userRoleEnum.MarketAdmin
                      "
                      mat-menu-item
                      (click)="onEdit(item.standardId)"
                    >
                      Edit
                    </button>
                    <button
                      mat-menu-item
                      (click)="closeMatMenuAndOpenDeleteModal(item, $event)"
                    >
                      Remove
                    </button>
                  </span>
                </mat-menu>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="row" *ngIf="equipmentItems.length > 0">
        <div class="col">
          <ngb-pagination
            class="float-right"
            [(page)]="page"
            [pageSize]="pageSize"
            [maxSize]="4"
            [rotate]="true"
            [ellipses]="true"
            [collectionSize]="collectionSize"
            (pageChange)="getAllNrbesBySelectedCountryId()"
          >
          </ngb-pagination>
        </div>
      </div>
      <div class="row">
        <div
          *ngIf="
            equipmentItems.length == 0 &&
              !loading &&
              !searchKey &&
              this.userRole == 4;
            else elseBlock
          "
        >
          Please select a country to view the standards.
        </div>

        <ng-template #elseBlock>
          <div *ngIf="equipmentItems.length == 0 && !loading && !searchKey">
            Sorry you do not have any standards for the country.
          </div>
        </ng-template>
        <div *ngIf="equipmentItems.length == 0 && searchKey">
          No results found based on search terms.&nbsp;&nbsp;<a
            href="javascript:void(0);"
            (click)="addSearchKey(''); getAllNrbesBySelectedCountryId()"
          >
            <span> Go Back </span>
          </a>
        </div>
      </div>
    </div>
    <app-mcd-loader *ngIf="loading"></app-mcd-loader>
  </mat-card-content>
</mat-card>
